<select class="form-control" v-model="selectedValue"><option v-for="(value, name) in allOptions" :value="value" v-text="name" :key="value"></option></select>